
export const newRequestColor = '#aac35e';
export const requestRejectedColor = '#d77777';
export const awaitingSettlementColor = '#A8BFD8';
export const enteredSettlementColor = '#10d5ff';
export const rejectedSettlementColor = '#FFBF00';
export const acceptedSettlementColor = '#008000';
export const defaultColor = 'grey';

export const DelegationStatus  = {
    NEW_REQUEST:"NEW_REQUEST",
    AWAITING_SETTLEMENT:"AWAITING_SETTLEMENT",
    REQUEST_REJECTED:"REQUEST_REJECTED",
    SETTLEMENT_ENTERED:"SETTLEMENT_ENTERED",
    SETTLEMENT_ACCEPTED:"SETTLEMENT_ACCEPTED",
    SETTLEMENT_REJECTED:"SETTLEMENT_REJECTED",


    getColor(status){
        switch (status) {
            case DelegationStatus.NEW_REQUEST:
                return newRequestColor;
            case DelegationStatus.AWAITING_SETTLEMENT:
                return awaitingSettlementColor;
            case DelegationStatus.SETTLEMENT_ENTERED:
                return enteredSettlementColor
            case DelegationStatus.SETTLEMENT_REJECTED:
                return rejectedSettlementColor
            case DelegationStatus.REQUEST_REJECTED:
                return requestRejectedColor
            case DelegationStatus.SETTLEMENT_ACCEPTED:
                return acceptedSettlementColor
            default:
                return  defaultColor;
                ;
        }
    }

}